import {
    createAttachedSignature, createDetachedSignature, createHash,
    getUserCertificates,
    isValidSystemSetup
} from "crypto-pro";
import axios from "axios";
import moment from "moment";
import FilesController from "@/controllers/FilesController";
import {Base64} from "js-base64";
import {mapActions} from "vuex";

export const setCryptoProFunctions = {
    data() {
        return {
            isValidSystemSetup: false,
            errorMessage: null,
            certificates: [],
            certificatesList: [],
            chosenCertificate: null,
            hash: null,
            signature: null,
            signingFile: false,
            signingUploadedFile: false,
            customUserId: null
        }
    },

    methods: {
        ...mapActions('checkFilled', {updateFiles: 'updateFiles'}),
        checkSystem() {
            isValidSystemSetup()
                .then(isValidSystemSetup => {
                    this.isValidSystemSetup = isValidSystemSetup;
                    console.log('valid: ', isValidSystemSetup);
                    if (isValidSystemSetup) {
                        this.getCertificates()
                    }
                })
                .catch((e) => {
                        this.isValidSystemSetup = false;
                        console.error(e)
                        this.errorMessage = e.message;
                        this.addNotification({
                            notificationStatus: "error",
                            notificationTime: 10000,
                            notificationMessage: e.message
                        })
                    }
                )
        },
        getCertificates() {
            getUserCertificates().then(async certificates => {
                this.certificates = certificates
                this.certificatesList = (await Promise.all(certificates.map(async (el) => {
                        let isValid;
                        const res = await el._cadesCertificate?.IsValid();
                        isValid = await res.Result;
                        let text = (await el.getCadesProp('SubjectName')).split(', ');
                        let textSN = text.filter(el => el.startsWith('SN='))[0]?.substring(3);
                        let textG = text.filter(el => el.startsWith('G='))[0]?.substring(2);
                        let name = (textSN && textG) ? textSN + ' ' + textG : el.name
                        return {value: el.thumbprint, text: name, isValid: isValid};
                    })
                )).filter(el => el.isValid)
            }).catch((error) => {
                this.errorMessage = error.message;
                console.error('getCertificates error', error.message)
            })
        },
        async uploadCryptoFile(file, scanType){
            console.log(this.customUserId)
            let fd = new FormData();
            fd.append('file', file);
            try {
                await FilesController.saveFile(scanType, file, String(this.customUserId ?? this.userId)).then(data => {
                    this.updateFiles(data);
                    this.initFiles(data)
                }).finally(() => {
                        console.log("update files")
                    }
                )
            } catch (e) {
                console.error(e)
                await this.addNotification({
                    notificationStatus: 'error',
                    notificationMessage: 'Ошибка загрузки',
                    timeout: 3000
                })
            }
        },
        async uploadSingedFile(fileData, scanType, useFileFormat = true) {
            const file = new File([Base64.toUint8Array(fileData.fileBytes)], fileData.fileName + (fileData.fileFormat && useFileFormat ? '.' + fileData.fileFormat : ''));
            await this.uploadCryptoFile(file, scanType)
        },
        async uploadSingFile(fileData, scanType, useFileFormat = true) {
            const file = new File([fileData.signature], fileData.fileName + (fileData.fileFormat && useFileFormat ? '.' + fileData.fileFormat : ''), {type: "text/plain"});
            await this.uploadCryptoFile(file, scanType)
        },
        async signFile(alias, nameLoading, scanType, customUserId = null) {
            this[nameLoading] = true
            this.signingFile = true;
            this.customUserId = customUserId;
            if (!this.chosenCertificate) {
                this.addNotification({notificationMessage: 'Выберите сертификат', notificationStatus: 'warning'})
                return;
            }
            const args = [...arguments].filter((_, i) => i >= 4);
            const cert = this.certificates.filter(el => el.thumbprint === this.chosenCertificate).shift();
            let text = (await cert.getCadesProp('SubjectName')).split(', ');
            let textSN = text.filter(el => el.startsWith('SN='))[0]?.substring(3);
            let textG = text.filter(el => el.startsWith('G='))[0]?.substring(2);
            let name = (textSN && textG) ? textSN + ' ' + textG : cert.name
            const signargs = args.join('') + `&cert_thumbprint=${cert.thumbprint}&cert_ca=${name}` +
                `&cert_date_start=${moment(cert.validFrom).format("DD.MM.YYYY")}&cert_date_end=${moment(cert.validTo).format("DD.MM.YYYY")}`
            let path;
            if (alias === 'getOrgReport'){
                path = `/api/reports/${alias}${signargs}`;
            } else {
                path = `/api/reports/getByAlias/${alias}${signargs}`;
            }
            await this.downloadBlobDocumentCrypto(path).finally(() => this[nameLoading] = false)
            if (!this.file) {
                this.addNotification({notificationMessage: 'Ошибка получения файла', notificationStatus: 'warning'})
                return;
            }
            this.changeFileToArrayBuffer().then(arrBuf => {
                createAttachedSignature(this.chosenCertificate, arrBuf)
                    .then(signature => {
                        this.uploadSingedFile({
                            fileBytes: signature,
                            withoutEncode: false,
                            fileName: `Файл подтверждения введенных данных (подписанный)`,
                            fileFormat: 'pdf'
                        }, scanType).then(() => this.signingFile = false)
                        this.customUserId = null;
                    })
                    .catch(e => {
                        this.addNotification({notificationMessage: e.message, notificationStatus: 'error'})
                        this.customUserId = null;
                    })
            })
        },
        base64ToArrayBuffer(base64) {
            var binaryString = atob(base64);
            var bytes = new Uint8Array(binaryString.length);
            for (var i = 0; i < binaryString.length; i++) {
                bytes[i] = binaryString.charCodeAt(i);
            }
            return bytes.buffer;
        },
        async signUploadedFile(fileId, signType, customUserId) {
            this.customUserId = customUserId;
            if (!this.chosenCertificate) {
                this.addNotification({notificationMessage: 'Выберите сертификат', notificationStatus: 'warning'})
                return;
            }
            await FilesController.getFile(fileId).then(response => {
                this.fileBase64 = response.file
                this.validate = true
                this.file = response.fileName
                this.fileArrayBuffer = this.base64ToArrayBuffer(response.file)
            })
            if (!this.file) {
                this.addNotification({notificationMessage: 'Ошибка получения файла', notificationStatus: 'warning'})
                return;
            }
            this.signingFile = true;
            this.changeFileToArrayBuffer().then(arrBuf => {
                createHash(arrBuf)
                    .then(msg => {
                        createDetachedSignature(this.chosenCertificate, msg)
                            .then(signature => {
                                this.uploadSingFile({
                                    signature: signature,
                                    withoutEncode: false,
                                    fileName: `${this.file}`,
                                    fileFormat: 'p7s'
                                }, signType).then(() => {this.signingFile = false; this.customUserId = null})
                            })
                            .catch(e => {
                                this.signingFile = false;
                                this.customUserId = null;
                                this.addNotification({notificationMessage: e.message, notificationStatus: 'error'})
                            })
                    })
            })
        },
        changeBlobToBase64(data) {
            return new Promise((res) => {
                const reader = new FileReader();
                reader.readAsDataURL(data);
                reader.onloadend = () => res(reader.result);
            })
        },
        changeFileToArrayBuffer() {
            return new Promise((res) => {
                if (this.fileArrayBuffer)
                    res(this.fileArrayBuffer);
                const reader = new FileReader();
                reader.readAsArrayBuffer(this.file);
                reader.onload = () => res(reader.result);
            })
        },
        async downloadBlobDocumentCrypto(api = '') {
            this.downloadingFileForPrint = true;
            await axios.get(api, {
                responseType: "blob",
                headers: {
                    Authorization: `Bearer   ${this.getKeycloakData?.token}`
                },
            })
                .then(response => {
                    this.changeBlobToBase64(response.data).then((base64) => this.fileBase64 = base64);
                    this.validate = true
                    this.file = response.data;
                    const reader = new FileReader();
                    reader.readAsArrayBuffer(response.data);
                    reader.onload = () => this.fileArrayBuffer = reader.result;
                })
                .catch(e => console.error(e))
                .finally(() => this.downloadingFileForPrint = false);
        }
    }
}